import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/generic/Navbar';

const PublicLayout = ({ children }) => {
  return (
    <div className="public-layout flex h-screen overflow-hidden bg-base-background dark:bg-black-primary">
      {/* <Navbar /> */}
      <main className="public-content flex-1 overflow-auto hide-scrollbar">
        <Outlet />
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export default PublicLayout;
